import React from 'react';

const Partner = () => {
  // Main Wrapper - Transparent to blend with your site's background
  const containerStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '40px',
    flexWrap: 'wrap',
    padding: '4rem 1rem',
    background: 'transparent',
    width: '100%',
  };

  // Glassmorphism Card with Purple accents
  const cardStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '300px',
    height: '130px',
    padding: '20px',
    backgroundColor: 'rgba(20, 10, 40, 0.4)', // Deep purple-tinted glass
    borderRadius: '24px',
    border: '1px solid rgba(139, 92, 246, 0.2)', // Soft violet border
    backdropFilter: 'blur(12px)',
    transition: 'all 0.5s cubic-bezier(0.2, 0.8, 0.2, 1)',
    cursor: 'pointer',
    position: 'relative',
  };

  const imageStyle = {
    maxWidth: '100%',
    maxHeight: '100%',
    objectFit: 'contain',
    display: 'block',
    transition: 'transform 0.5s ease',
  };

  // Interaction Logic for the "Purple Glow" effect
  const handleMouseEnter = (e) => {
    const card = e.currentTarget;
    card.style.transform = 'translateY(-10px)';
    card.style.border = '1px solid rgba(139, 92, 246, 0.8)';
    card.style.boxShadow = '0 15px 40px -10px rgba(139, 92, 246, 0.4)';
    card.querySelector('img').style.transform = 'scale(1.05)';
  };

  const handleMouseLeave = (e) => {
    const card = e.currentTarget;
    card.style.transform = 'translateY(0)';
    card.style.border = '1px solid rgba(139, 92, 246, 0.2)';
    card.style.boxShadow = 'none';
    card.querySelector('img').style.transform = 'scale(1)';
  };

  return (
    <section style={containerStyle}>
      {/* Meta Business Partner */}
      <div 
        style={cardStyle}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <img 
          src="https://taqnyat.sa/assets/images/news/meta_business_partner.webp" 
          alt="Meta Business Partner" 
          style={imageStyle} 
        />
      </div>

      {/* Google Partner */}
      <div 
        style={{
          ...cardStyle, 
          mixBlendMode: 'screen' // Magic: Removes the white background from the Google PNG
        }}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <img 
          src="https://www.dgtls.com/images-general/landingpages/google-partner/image-thumb__2153__og-image/28042022_dgtls_news_876x846_google-partner_1%20%E2%80%93%202.png" 
          alt="Google Partner" 
          style={{...imageStyle, filter: 'brightness(1.1)'}} 
        />
      </div>
    </section>
  );
};

export default Partner;